import * as React from 'react';

import { ISetRedundantSupply, ISetSlotRouterItemFront, IUpdatePowerSupply } from '../../../actions';
import { IAvailablePower } from '../../../types/store/availablePower';
import { IBudget } from '../../../types/store/budget';
import { IRouterData } from '../../../types/store/routerData';
import { ISlotsItems } from '../../../types/store/slotsItems';
import Stats from './../Stats';
import BackPanel from './BackPanel';
import FrontPanel from './FrontPanel';

interface IModalConfiguratorProps {
  routerData: IRouterData;
  slotsItems: ISlotsItems;
  budget: IBudget;
  availablePower: IAvailablePower;
  setSlotRouterItem: ISetSlotRouterItemFront;
  setRedundantSupply: ISetRedundantSupply;
  updatePowerSupply: IUpdatePowerSupply;
}

const ModalConfigurator: React.SFC<IModalConfiguratorProps> = props => {
  return (
    <div className="dragdrop-section col-md-7 col-xxl-12">
      <div className="row-xl">
        <FrontPanel {...props} />
        <BackPanel
          budget={props.budget}
          routerData={props.routerData}
          slotsItems={props.slotsItems}
          setRedundantSupply={props.setRedundantSupply}
          updatePowerSupply={props.updatePowerSupply}
        />
        <Stats {...props} />
      </div>
    </div>
  );
};

export default ModalConfigurator;



// WEBPACK FOOTER //
// ./src/components/Configurator/ModalConfigurator/index.tsx